module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm2_en.32b75b6d54ae7b07f352fd921b0c495a.png";